import { render, staticRenderFns } from "./NavbarToggleButton.vue?vue&type=template&id=580b57b6&scoped=true&"
import script from "./NavbarToggleButton.vue?vue&type=script&lang=js&"
export * from "./NavbarToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./NavbarToggleButton.vue?vue&type=style&index=0&id=580b57b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580b57b6",
  null
  
)

export default component.exports